
class ParamService {
    parseParams() {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.has("tags") ? searchParams.get("tags").split(',') : null
    }

    createParams(filters) {
        const paramParts = [];
        if (filters) {
            const tagSlugs = filters.map(f=>f.slug).join(',');
            paramParts.push(`tags=${tagSlugs}`);
        }
        const paramsUrl = paramParts.length ? `?${paramParts.join("&")}` : "";
        return paramsUrl;
    }
}

export const paramService = new ParamService();
